import type { SvgIconProps } from "@mui/material/SvgIcon";
import SvgIcon from "@mui/material/SvgIcon";

type InterpolateFilledIconProps = SvgIconProps;

const InterpolateFilledIcon = ({ ...props }: InterpolateFilledIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <circle cx="18" cy="6" r="3" stroke="none" fill="currentColor" />
        <line x1="15.8787" y1="8.1213" x2="14.1213" y2="9.8787" stroke="currentColor" strokeWidth="1" />
        <circle cx="12" cy="12" r="3" stroke="none" fill="currentColor" />
        <line x1="9.8787" y1="14.113" x2="8.1213" y2="15.8787" stroke="currentColor" strokeWidth="1" />
        <circle cx="6" cy="18" r="3" stroke="none" fill="currentColor" />
      </svg>
    </SvgIcon>
  );
};

export default InterpolateFilledIcon;
